import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Loader2, ShieldOff, ImageOff, Maximize2 } from "lucide-react";
import { useSecureDoc } from "@/lib/kyc";

// Authenticated document thumbnail (blob URL, never a public link). Click → full-size viewer.
export const SecureDocImage = ({ path, label = "", size = "h-20 w-28", testId = "secure-doc", className = "", fit = "cover" }) => {
  const { t } = useApp();
  const { url, status } = useSecureDoc(path);
  const [open, setOpen] = useState(false);
  const box = `${size} rounded-lg border grid place-items-center overflow-hidden shrink-0 ${className}`;
  const border = { borderColor: "var(--yalola-border)", background: "var(--yalola-surface-alt)", color: "var(--yalola-text-muted)" };
  if (status === "loading") return <div className={box} style={border} data-testid={`${testId}-loading`}><Loader2 size={16} className="animate-spin" /></div>;
  if (status === "purged") return <div className={`${box} text-[10px] text-center px-1`} style={border} data-testid={`${testId}-purged`} title={t("kyc.doc_purged_title", "Document supprimé (politique de conservation)")}><ShieldOff size={14} /><span>{t("kyc.doc_purged", "Supprimé (rétention)")}</span></div>;
  if (status !== "ok") return <div className={box} style={border} data-testid={`${testId}-error`}><ImageOff size={16} /></div>;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={`${box} relative group`} style={border} data-testid={testId} title={label}>
        <img src={url} alt={label || "document"} className={`h-full w-full ${fit === "contain" ? "object-contain" : "object-cover"}`} />
        <span className="absolute inset-0 grid place-items-center bg-black/0 group-hover:bg-black/30 text-white opacity-0 group-hover:opacity-100 transition-opacity"><Maximize2 size={16} /></span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl" data-testid={`${testId}-viewer`}>
          <DialogHeader>
            <DialogTitle className="font-display text-base">{label || t("kyc.doc", "Document")}</DialogTitle>
            <DialogDescription className="text-xs">{t("kyc.doc_encrypted", "Document chiffré — consultation journalisée.")}</DialogDescription>
          </DialogHeader>
          <img src={url} alt={label || "document"} className="max-h-[75vh] w-auto mx-auto rounded-xl object-contain" />
        </DialogContent>
      </Dialog>
    </>
  );
};
